import { makeStyles, createStyles, MuiTheme } from '@kis-technologies/kis-ui';

export const useStyles = (props: { zoomSpeed?: number; showTransition: boolean }) =>
  makeStyles((theme: MuiTheme) =>
    createStyles({
      forwardButton: {
        minWidth: '400px',
        maxWidth: 'fit-content',
        transition: props.showTransition && props.zoomSpeed ? `transform ${props.zoomSpeed}s ease-in` : 'none',
        transform: 'translateZ(0)',
        [theme.breakpoints.down('lg')]: {
          minWidth: '375px'
        }
      },
      overlayContainer: {
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        alignContent: 'center',
        borderRadius: '8px',
        backgroundColor: 'white',
        padding: '56px 45px 0px 45px',
        justifyContent: 'space-around',
        boxShadow: '0 3px 9px 0 rgba(0, 0, 0, 0.2)',
        width: 1160,
        height: 450,
        [theme.breakpoints.down('lg')]: {
          width: 1010
        }
      }
    })
  );
